// const bestSellersSwiper = new Swiper('.BestSellers__Slider', {
//   // Optional parameters
//   slidesPerView: 1,
//   spaceBetween: 30,
//   speed: 1000,
//   loop: true,
//   loopedSlides: 3,
//   grabCursor: true,

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     type: 'bullets',
//     clickable: true,
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

//   // Breakpoints
//   breakpoints: {
//     525: {
//       slidesPerView: 2,
//       spaceBetween: 50,
//     },
//     992: {
//       slidesPerView: 3,
//       spaceBetween: 30,
//     },
//     1200: {
//       slidesPerView: 4,
//       spaceBetween: 30,
//     }
//   }
// });

// const reviewsSwiper = new Swiper('.ReviewsSlider__Slider', {
//   // Optional parameters
//   slidesPerView: 1,
//   spaceBetween: 30,
//   speed: 1000,
//   loop: true,
//   loopedSlides: 3,
//   grabCursor: true,

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     type: 'bullets',
//     clickable: true,
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

//   // Autoplay
//   autoplay: {
//     delay: 4000,
//   },

//   // Breakpoints
//   breakpoints: {
//     768: {
//       slidesPerView: 2,
//       spaceBetween: 50,
//     },
//     992: {
//       slidesPerView: 3,
//       spaceBetween: 30,
//     },
//   }
// });

// const blogPostsSwiper = new Swiper('.BlogPosts__Slider', {
//   // Optional parameters
//   slidesPerView: 1,
//   spaceBetween: 40,
//   speed: 1000,
//   loop: true,
//   loopedSlides: 2,
//   grabCursor: true,

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     type: 'bullets',
//     clickable: true,
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

//   // Autoplay
//   autoplay: {
//     delay: 4000,
//   },

//   // Breakpoints
//   breakpoints: {
//     525: {
//       slidesPerView: 2,
//       spaceBetween: 50,
//     },
//     868: {
//       slidesPerView: 3,
//       spaceBetween: 50,
//     },
//     1200: {
//       slidesPerView: 4,
//       spaceBetween: 50,
//     }
//   }
// });

// const storeFeaturesSwiper = new Swiper('.StoreFeatures__Slider', {
//   // Optional parameters
//   slidesPerView: 1,
//   spaceBetween: 50,
//   speed: 1000,
//   loop: true,
//   loopedSlides: 2,
//   // grabCursor: true,

//   // // If we need pagination
//   // pagination: {
//   //   el: '.swiper-pagination',
//   //   type: 'bullets',
//   //   clickable: true,
//   // },

//   // // Navigation arrows
//   // navigation: {
//   //   nextEl: '.swiper-button-next',
//   //   prevEl: '.swiper-button-prev',
//   // },

//   // Autoplay
//   autoplay: {
//     delay: 4000,
//   },

//   // Breakpoints
//   breakpoints: {
//     576: {
//       slidesPerView: 2,
//       spaceBetween: 50,
//     },
//     768: {
//       slidesPerView: 3,
//       spaceBetween: 50,
//     },
//   }
// });

// const productGalerySwiper = new Swiper('.Product__Galery-Slider', {
//   // Optional parameters
//   slidesPerView: 3,
//   spaceBetween: 20,
//   speed: 500,
//   // loop: true,
//   // loopedSlides: 2,
//   grabCursor: true,

//   // // If we need pagination
//   // pagination: {
//   //   el: '.swiper-pagination',
//   //   type: 'bullets',
//   //   clickable: true,
//   // },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

//   // Breakpoints
//   breakpoints: {
//     768: {
//       spaceBetween: 30,
//     },
//     1200: {
//       spaceBetween: 40,
//     }
//   }
// });

// const productMainImageSwiper = new Swiper('.Product__Main-Image-Slider', {
//   // Optional parameters
//   slidesPerView: 1,
//   spaceBetween: 40,
//   speed: 500,

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

//   thumbs: {
//     swiper: productGalerySwiper
//   }
// });

// const comboProductsSwiper = new Swiper('.ComboProducts__Slider', {
//   // Optional parameters
//   slidesPerView: 1,
//   spaceBetween: 30,
//   speed: 1000,
//   loop: true,
//   loopedSlides: 3,
//   grabCursor: true,

//   // If we need pagination
//   pagination: {
//     el: '.swiper-pagination',
//     type: 'bullets',
//     clickable: true,
//   },

//   // Navigation arrows
//   navigation: {
//     nextEl: '.swiper-button-next',
//     prevEl: '.swiper-button-prev',
//   },

//   // Breakpoints
//   breakpoints: {
//     525: {
//       slidesPerView: 2,
//       spaceBetween: 50,
//     },
//     992: {
//       slidesPerView: 3,
//       spaceBetween: 30,
//     },
//     1200: {
//       slidesPerView: 4,
//       spaceBetween: 30,
//     }
//   }
// });

let swippers = {
  bestSellersSwiper: undefined,
  reviewsSwiper: undefined,
  blogPostsSwiper: undefined,
  storeFeaturesSwiper: undefined,
  productGalerySwiper: undefined,
  productMainImageSwiper: undefined,
  comboProductsSwiper: undefined
}

// Create a function that recieves a class and then creates an observer for each element with that class, then that observer should create a new Swiper instance when that element is created
const createSwiperObserver = ({ name, className, config }) => {
  const observer = new MutationObserver((mutationsList, observer) => {
    const element = document.querySelector(className);
    if (element) {
      element.classList.remove('d-none')
      const swiper = new Swiper(className, config);
      swippers[name] = swiper;
      observer.disconnect();
    }
  });

  return observer
}

const bestSellerSwiperObserver = createSwiperObserver({
  name: 'bestSellersSwiper',
  className: '.BestSellers__Slider',
  config: {
    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 0,
    speed: 1000,
    loop: true,
    loopedSlides: 3,
    grabCursor: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Breakpoints
    breakpoints: {
      525: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  }
});
const reviewsSwiperObserver = createSwiperObserver({
  name: 'reviewsSwiper',
  className: '.ReviewsSlider__Slider',
  config: {
    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1000,
    loop: true,
    loopedSlides: 3,
    grabCursor: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Autoplay
    autoplay: {
      delay: 4000,
    },

    // Breakpoints
    breakpoints: {
      768: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
    }
  }
});
const blogPostsSwiperObserver = createSwiperObserver({
  name: 'blogPostsSwiper',
  className: '.BlogPosts__Slider',
  config: {
    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 40,
    speed: 1000,
    loop: true,
    loopedSlides: 2,
    grabCursor: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Autoplay
    autoplay: {
      delay: 4000,
    },

    // Breakpoints
    breakpoints: {
      525: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      868: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 50,
      }
    }
  }
});
const storeFeaturesSwiperObserver = createSwiperObserver({
  name: 'storeFeaturesSwiper',
  className: '.StoreFeatures__Slider',
  config: {
    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 50,
    speed: 1000,
    loop: true,
    loopedSlides: 2,
    // grabCursor: true,

    // // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    //   type: 'bullets',
    //   clickable: true,
    // },

    // // Navigation arrows
    // navigation: {
    //   nextEl: '.swiper-button-next',
    //   prevEl: '.swiper-button-prev',
    // },

    // Autoplay
    autoplay: {
      delay: 4000,
    },

    // Breakpoints
    breakpoints: {
      576: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      768: {
        slidesPerView: 3,
        spaceBetween: 50,
      },
    }
  }
});
const productGalerySwiperObserver = createSwiperObserver({
  name: 'productGalerySwiper',
  className: '.Product__Galery-Slider',
  config: {
    // Optional parameters
    slidesPerView: 3,
    spaceBetween: 25,
    speed: 500,
    // loop: true,
    // loopedSlides: 2,
    grabCursor: true,

    // // If we need pagination
    // pagination: {
    //   el: '.swiper-pagination',
    //   type: 'bullets',
    //   clickable: true,
    // },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Breakpoints
    breakpoints: {
      768: {
        spaceBetween: 30,
      },
      1200: {
        spaceBetween: 40,
      }
    }
  }
});

const interval = setInterval(() => {
  if(swippers.productGalerySwiper) {
    const productMainImageSwiperObserver = createSwiperObserver({
      name: 'productMainImageSwiper',
      className: '.Product__Main-Image-Slider',
      config: {
        // Optional parameters
        slidesPerView: 1.07,
        spaceBetween: 16,
        speed: 500,

        // Navigation arrows
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },

        thumbs: {
          swiper: swippers.productGalerySwiper
        }
      }
    });

    productMainImageSwiperObserver.observe(
      document.documentElement,
      { childList: true, subtree: true }
    );

    setTimeout(() => {
      productMainImageSwiperObserver.disconnect();
    }, 8000);

    clearInterval(interval);
  }
}, 500);

const comboProductsSwiperObserver = createSwiperObserver({
  name: 'comboProductsSwiper',
  className: '.ComboProducts__Slider',
  config: {
    // Optional parameters
    slidesPerView: 1,
    spaceBetween: 30,
    speed: 1000,
    loop: true,
    loopedSlides: 3,
    grabCursor: true,

    // If we need pagination
    pagination: {
      el: '.swiper-pagination',
      type: 'bullets',
      clickable: true,
    },

    // Navigation arrows
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },

    // Breakpoints
    breakpoints: {
      525: {
        slidesPerView: 2,
        spaceBetween: 50,
      },
      992: {
        slidesPerView: 3,
        spaceBetween: 30,
      },
      1200: {
        slidesPerView: 4,
        spaceBetween: 30,
      }
    }
  }
});

const observers = [
  bestSellerSwiperObserver,
  reviewsSwiperObserver,
  blogPostsSwiperObserver,
  storeFeaturesSwiperObserver,
  productGalerySwiperObserver,
  comboProductsSwiperObserver
]

document.addEventListener('DOMContentLoaded', () => {
  observers.forEach(observer => {
    observer.observe(
      document.documentElement,
      { childList: true, subtree: true }
    );

    setTimeout(() => {
      observer.disconnect();
    }, 8000);
  });
})